/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-title-font-family',
  templateUrl: './theme-option-title-font-family.component.html',
  styleUrls: ['./theme-option-title-font-family.component.css']
})
export class ThemeOptionTitleFontFamilyComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'title_fontFamily';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: string, type?: ChartType) {
    this.themeOptions.setOption(this.optionType, value, type ? [type] : undefined);
  }

}
